module.exports = __webpack_public_path__ + "static/media/img_07.41b7debf.png";